module.exports = __webpack_public_path__ + "img/top_img.5ab96f31.png";